import CancelButtonCanceled from './CancelButtonCanceled';
import CancelButtonConfirmation from './CancelButtonConfirmation';
import CancelButtonInitial from './CancelButtonInitial';
import CancelButtonLoading from './CancelButtonLoading';

const CancelButton = {
  Canceled: CancelButtonCanceled,
  Confirmation: CancelButtonConfirmation,
  Initial: CancelButtonInitial,
  Loading: CancelButtonLoading,
};

export default CancelButton;
